import en_US from './en-US/';
import es from './es/';

export default {
  ...en_US,
  ...es,
};
